/**
 * Интерфейс для одного из типов чатов ChatModel.ChatType
 */
class ClientTypedChat {
  /**
   * @param room {ClientChatRoom}
   * @param type {Number}
   */
  constructor(room, type) {
    this.room = room;
    this.type = type;
  }

  /**
   * Отправляет сообщение в чат
   * @param text {string} - Текст сообщения
   * @param parentOrderId {string?} - ID родительского заказа
   */
  sendMessage(text, parentOrderId) {
    this.room.sendMessage(text, parentOrderId, this.type);
  }

  /**
   * Отправляет запрос для получения истории чата
   * @param offset {Number?}
   * @param limit {Number?}
   */
  getHistory(offset, limit) {
    this.room.getHistory(this.type, offset, limit);
  }

  /**
   * Объект сообщений чата
   * @returns {Object}
   */
  // TODO: проверить производительность
  get messages() {
    return Object.fromEntries(Object.entries(this.room.messages)
      .filter(([, message]) => message.type === this.type));
  }

  /**
   * Отправляет запрос для получения истории чата
   * @param messageHash {string} - Hash сообщения
   * @param roomId {Number} - ID комнаты
   * @param type {number} - тип сообщений ChatModel.ChatType
   */
  markMessageAsRead(messageHash, roomId, type) {
    this.room.markMessageAsRead(messageHash, roomId, type);
  }
}

export default ClientTypedChat;
